import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import styled from '@emotion/styled';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import DataTable from './DataTable';

import {deleteAdminCustomer, deleteAdminVariant, getAdminCustomerOrders, getAdminCustomers, updateAdminCustomer} from '../../network';
import {formatDate, padding} from '../../utils/formatter';
import {capitalize} from '../../helpers/Helper';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% - 14.75rem);
  height: 100vh;
  //height: 100%;
  
  padding: 1rem 1.5rem 0 1.5rem;
`;

const PageHeader = styled.h1`
  height: 1.25rem;
  font-size: 1.25rem;
  line-height: 1.25rem;
  
  font-family: OpticianSans, serif;
  font-style: normal;
  font-weight: normal;
  
  color: var(--color-gray-500);
`;

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: -webkit-fill-available;
  
  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;
  
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
  
  overflow-y: hidden;
`;

const Tag = styled.div`
  display: flex;
  width: fit-content;
  padding: var(--space-4) var(--space-6);

  font-size: var(--font-12);
  font-weight: 500;
  color: ${props => props.color ? `var(--color-${props.color}-800)` : ''};
  background-color: ${props => props.color ? `var(--color-${props.color}-100)` : ''};
  box-shadow: ${props => props.color ? `0 0 0 1px var(--color-${props.color}-300)` : '0 0 0 1px #C8E1D2'};
  border-radius: var(--space-4);
`;

const Label = styled.span`
  color: var(--color-gray-600);
  width: 6rem;
`;

const OrderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: var(--space-24);
  margin-right: var(--space-24);
  margin-bottom: var(--space-16);
  & > span:first-of-type {
    font-weight: 500;
    color: var(--company-dark);
  }
  & > span:last-of-type {
    color: var(--color-gray-700);
  }
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: var(--space-24);
  margin-bottom: 1rem;
  > a {
    color: var(--company-dark);
    font-weight: 500;
    width: 12.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:last-of-type {
      margin-bottom: var(--space-28); 
    }
`;

const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  justify-content: space-between;
  padding-top: var(--space-16);
  padding-left: var(--space-20);
  padding-right: var(--space-20);
  padding-bottom: var(--space-8);
  border-top: 1px solid var(--color-gray-300);
  > button {
    border: none;
    box-shadow: none;
    background: none;
    padding: var(--space-6) var(--space-8);
    border-radius: var(--space-4);
    color: var(--company-dark);
    font-size: var(--font-16);
    font-weight: normal;
    &:hover {
      background-color: var(--color-gray-200);
      transition: background-color 0.3s ease-in;
    }
    &:last-of-type {
      color: var(--color-red-700);
    }
    &:disabled {
      color: var(--color-gray-500);
      cursor: not-allowed;
    }
  }
`;

const InnerDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: calc(100% - var(--space-32));
  line-height: 1.2;
  vertical-align: center;
  font-size: var(--font-14);
  
  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;
  
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
  
  overflow-y: hidden;

  background: white;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;

  padding: 0 1.5rem 0 1.5rem;

  justify-content: space-between;
  align-items: center;
`;

const FilterSection = styled.div`
  display: flex;
  align-items: center;

  > span {
    height: 0.875rem;

    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
    color: var(--color-gray-600);
  }
`;

const Dropdown = styled.div`
  border: 1px solid var(--color-gray-300);
  box-sizing: border-box;
  border-radius: 1.5rem;
  
  margin: 0 0 0 1rem;
  padding: 0 0.75rem 0 0.75rem;
  
  > select {
    height: 1.5rem;
    
    background: transparent;
    
    border: 0;
  
    appearance: none;
    outline: none;

    
    font-size: 0.75rem;
    font-weight: 500;
    
    color: var(--color-gray-800);
  }
  
  > img {
    margin-left: var(--space-8);
  }
`;

const SearchSection = styled.div`
  display: flex;
  align-items: center;
  width: 30%;
  
  > img {
    position: relative;
    left: 90%;
  }
  
  > input {
    width: 100%;
    height: 1.875rem;
    
    padding: 1rem;
    background: white;
    
    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: 4px;
    
    color: var(--color-gray-500);
    
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
  }
`;

const CellText = styled.span`
  width: 90%;
  
  
  font-style: normal;
  //font-weight: 500;
  font-size: 0.875rem;
  line-height: 1rem;

  color: var(--color-gray-900);
  
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Divider = styled.div`
  width: calc(100% - var(--space-48));
  margin-top: var(--space-8);
  margin-bottom: var(--space-24);
  margin-left: var(--space-24);
  height: 1px;
  background-color: var(--color-gray-300);
`;

const MasterContainer = styled.div`
  //height: -webkit-fill-available;
  height: calc(100vh - 2.5rem); // desperation
  flex-grow: 1;
  margin-right: 1.5rem;
`;

const DetailContainer = styled.div`
  width: 24rem;
  height: calc(100vh - 4.5rem); // desperation
`;

function BackOfficeCustomers({auth}) {
    const location = useLocation();
    const {customerId} = location.state || {};
    const [customers, setCustomers] = useState([]);
    const [searchText, setSearchText] = useState(customerId);
    const [sort, setSort] = useState(null);
    const [filter, setFilter] = useState('');
    const [details, setDetails] = useState(null);
    const [detailsEdit, setDetailsEdit] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(25);
    const [pageCount, setPageCount] = useState(1);
    
    const adminToken = auth ? auth.token : null;
    
    const filters = [
        {
            value: 'individual',
            text: 'Individual'
        },
        {
            value: 'company',
            text: 'Company'
        }
    ];
    const headers = [
        {
            title: 'Customer Name',
            sortable: true,
            sort: 'first_name'
        },
        {
            title: 'Customer Email',
            sortable: true,
            sort: 'email'
        },
        {title: 'Type'},
        {
            title: 'Status',
            sortable: true,
            sort: 'active'
        }
    ];

    useEffect(() => search(searchText), [searchText, currentPage, sort, filter]);

    // useEffect(()=> onRowSelect(customerId), []);

    const search = searchText => {
        getAdminCustomers(adminToken, searchText, currentPage, pageLimit, sort, filter ? {type: filter} : null)
            .then(result => {
                setDetails(null);
                setDetailsEdit(null);
                setCustomers([...result.data]);
                setPageCount(Math.ceil(result.total / pageLimit));
            })
            .catch(error => console.error(error));
    };

    const removeCustomer = id => {
        deleteAdminCustomer(adminToken, id)
            .then(() => {
                setDetails(null);
                setDetailsEdit(null);
                search(searchText);
            })
            .catch(error => console.error(error));
    };

    const changeSort = sort => setSort(sort);

    const changePage = direction => {
        if (currentPage === 1 && direction < 0) return;
        if (currentPage === pageCount && direction > 0) return;

        setCustomers([]);
        setCurrentPage(currentPage + (direction));
    };

    const debouncedSearchText = _.debounce(query => {
        setSearchText(query);
    }, 400);

    const handleSearchChange = e => {
        const value = e.target.value.trim();
        debouncedSearchText(value);
    };
  
    const onRowSelect = data => {
        getAdminCustomerOrders(data._id, adminToken, 1, 5)
            .then(result => {
                let orders = [];
                result.data.forEach(order => {
                    orders.push({
                        ticket: order.ticket,
                        order_date: order.created
                    });
                });

                const details = {
                    customer: data,
                    orders
                };
                setDetails(details);
                setDetailsEdit(null);
            })
            .catch(error => console.error(error));
    };

    const dataRows = data => {
        let rows = [];
        data.map(item => {
            rows.push({
                onRowSelect,
                data: item,
                view: <>
                    <CellText>{item.first_name} {item.last_name}</CellText>
                    <CellText style={{
                        color: '#049CBE',
                        cursor: 'pointer',
                        fontWeight: 500
                    }}>{item.email}</CellText>
                    <CellText>{capitalize(item.type)}</CellText>
                    {item.active ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>}
                </>
            });
        });
        return rows;
    };

    const handleEditChange = e => {
        const {value, name} = e.target;
        setDetailsEdit({
            ...detailsEdit,
            [name]: value
        });
    };

    const evalPrimaryAction = () => {
        if (!detailsEdit) setDetailsEdit({...details.customer});
        else {
            // eval if valid information entered, collect updates and update customer
            updateAdminCustomer(adminToken, detailsEdit._id, detailsEdit)
                .then(result => search(searchText))
                .catch(error => console.error(error));
        }
    };

    const evalSecondaryAction = () => {
        if (detailsEdit) setDetailsEdit(null);
        else removeCustomer(details.customer._id);
    };

    return (
        <Container>
            <MasterContainer>
                <PageHeader>CUSTOMERS</PageHeader>
                <ContentContainer>
                    <Row style={{marginBottom: '1rem'}}>
                        <FilterSection>
                            <span>Filter by</span>

                            <Dropdown>
                                <select value={filter} onChange={e => setFilter(e.target.value)}>
                                    <option value=''>All</option>
                                    {
                                        filters.map((filter, index) => {
                                            return <option key={`BackofficeCustomersFilterOption_${index}`} value={filter.value}>{filter.text}</option>;
                                        })
                                    }
                                </select>
                                <img alt='dropdown' src='/icons/chevron.svg'/>
                            </Dropdown>
                        </FilterSection>

                        <SearchSection>
                            <img src='/icons/search.svg' alt='search icon'/>
                            <input placeholder='Search here...' type='text' defaultValue={customerId} onChange={handleSearchChange}/>
                        </SearchSection>
                    </Row>

                    <DataTable
                        headers={headers}
                        rows={dataRows(customers)}
                        changeSort={changeSort}
                        spacing={'30% 30% 20% 20%'}
                        currentPage={currentPage}
                        pageCount={pageCount}
                        pageBack={() => changePage(-1)}
                        pageNext={() => changePage(1)}
                    />
                </ContentContainer>
            </MasterContainer>

            {
                details && <DetailContainer>
                    <PageHeader>DETAILS</PageHeader>
                    <InnerDetailContainer>
                        <DetailRow>
                            <Label>Name:</Label>
                            <span>{details.customer.first_name} {details.customer.last_name}</span>
                        </DetailRow>
                        <DetailRow>
                            <Label>Email:</Label>
                            <a href={`mailto: ${details.customer.email}`}>{details.customer.email}</a>
                        </DetailRow>
                        <DetailRow>
                            <Label>Type:</Label>
                            {
                                detailsEdit ?
                                    <Dropdown style={{margin: '0'}}>
                                        <select name="type" value={detailsEdit.type} onChange={handleEditChange}>
                                            {
                                                filters.map((filter, index) => {
                                                    return <option key={`BackofficeCustomersEditTypeOption_${index}`} value={filter.value}>{filter.text}</option>;
                                                })
                                            }
                                        </select>
                                        <img alt='dropdown' src='/icons/chevron.svg'/>
                                    </Dropdown>
                                    : <span>{capitalize(details.customer.type)}</span>
                            }
                        </DetailRow>
                        {
                            details.customer.contact && <DetailRow>
                                <Label>Contact:</Label>
                                <a href={`tel:+${details.customer.contact}`}>{`+${details.customer.contact}`}</a>
                            </DetailRow>
                        }
                        <DetailRow>
                            <Label>Status:</Label>
                            {
                                detailsEdit ?
                                    <Dropdown style={{margin: '0'}}>
                                        <select name="active" value={detailsEdit.active} onChange={handleEditChange}>
                                            {
                                                [{
                                                    value: true,
                                                    text: 'Active'
                                                }, {
                                                    value: false,
                                                    text: 'Inactive'
                                                }].map((filter, index) => {
                                                    return <option key={`BackofficeCustomersEditStatusOption_${index}`} value={filter.value}>{filter.text}</option>;
                                                })
                                            }
                                        </select>
                                        <img alt='dropdown' src='/icons/chevron.svg'/>
                                    </Dropdown>
                                    : details.customer.active
                                    ? <Tag color="green">Active</Tag>
                                    : <Tag color="red">Inactive</Tag>
                            }
                        </DetailRow>
                        {/*<DetailRow>*/}
                        {/*    <Label>Status:</Label>*/}
                        {/*    <Tag>Registered</Tag>*/}
                        {/*</DetailRow>*/}
                        <Divider/>
                        {
                            details.orders.map((order, index) => {
                                return <OrderItem key={`OrderItem_${index}`}>
                                    <span>Order {padding(order.ticket, 8)}</span>
                                    <span>{formatDate(order.order_date, 'MMM DD, YYYY')}</span>
                                </OrderItem>;
                            })
                        }
                        <ActionsBar>
                            <button onClick={evalPrimaryAction}>{detailsEdit ? 'Save Customer' : 'Edit Customer'}</button>
                            <button onClick={evalSecondaryAction} disabled={details.customer && !details.customer.active}>{detailsEdit ? 'Cancel' : 'Delete'}</button>
                        </ActionsBar>
                    </InnerDetailContainer>
                </DetailContainer>
            }
        </Container>
    );
}

const mapStateToProps = state => ({
    auth: state.auth,
    user: state.user
});

export default connect(mapStateToProps, null)(BackOfficeCustomers);
